import { render, staticRenderFns } from "./ModalLink.vue?vue&type=template&id=63011674&scoped=true&"
import script from "./ModalLink.vue?vue&type=script&lang=js&"
export * from "./ModalLink.vue?vue&type=script&lang=js&"
import style0 from "./ModalLink.vue?vue&type=style&index=0&id=63011674&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63011674",
  null
  
)

export default component.exports